import { useEffect, useState } from "react";
import { Loader2, Play } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const CaptureMedia = ({ captureId, kind, testid = "capture-media" }) => {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => () => url && URL.revokeObjectURL(url), [url]);
  if (kind === "text") return null;
  const load = async () => {
    setBusy(true);
    try { setUrl(URL.createObjectURL((await api.get(`/captures/${captureId}/media`, { responseType: "blob" })).data)); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!url) {
    return (
      <button data-testid={`${testid}-load-btn`} onClick={load} className="inline-flex items-center gap-1.5 text-xs font-semibold c-accent">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Play className="w-3.5 h-3.5" />} {kind === "audio" ? "Escuchar audio original" : "Ver foto original"}
      </button>
    );
  }
  return kind === "audio"
    ? <audio data-testid={`${testid}-audio`} controls autoPlay src={url} className="w-full h-10" />
    : <img data-testid={`${testid}-image`} src={url} alt="Captura" className="w-full max-h-72 object-contain rounded-lg" />;
};
